export default "__VITE_ASSET__DeFQ7u8___"